// extracted by mini-css-extract-plugin
export var avatarContainer = "_9v-0";
export var avatarTypingWave = "_9v-i";
export var gray = "_9v-f";
export var green = "_9v-c";
export var icon = "_9v-9";
export var image = "_9v-1";
export var lg = "_9v-6";
export var md = "_9v-5";
export var presenceDot = "_9v-b";
export var red = "_9v-d";
export var sm = "_9v-4";
export var status = "_9v-a";
export var typingDot = "_9v-h";
export var typingPill = "_9v-g";
export var xl = "_9v-7";
export var xs = "_9v-3";
export var xxl = "_9v-8";
export var xxs = "_9v-2";
export var yellow = "_9v-e";